// extracted by mini-css-extract-plugin
module.exports = {"decisionsTable":"DecisionsTable_decisionsTable__3sQtr","decisionsTable__embedded":"DecisionsTable_decisionsTable__embedded__2yLA8"};